import { datadogRum } from '@datadog/browser-rum';
import { Auth } from 'aws-amplify';

interface CognitoUserInfo {
  attributes: {
    email: string;
    email_verified: boolean;
    family_name: string;
    given_name: string;
    sub: string;
  };
}

export const setUser = async (): Promise<void> => {
  const userInfo = await (Auth.currentUserInfo() as Promise<CognitoUserInfo>);
  datadogRum.setUser({
    id: userInfo.attributes.sub,
    name: `${userInfo.attributes.given_name} ${userInfo.attributes.family_name}`,
    email: userInfo.attributes.email,
  });
};

export const clearUser = (): void => {
  datadogRum.clearUser();
};
